export default __webpack_public_path__ + "static/redundancy-2357f8f4a7d9477b7fd76a385067fb0a.png";